import React, {useReducer} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import {showerSideOptionsGroups, SIDE_POSITIONS} from "../../../core/constants";
import WithClickCount from "../../../hocs/withClickCount";
import {featureInterface} from "../../../../../interfaces/featureInterface";
// import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";


const GroheFeatureOptionsSide = (props) => {

  const {lookActiveFeature, updateCanvasCount} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  if (!lookActiveFeature || !showerSideOptionsGroups.includes(lookActiveFeature.partId)) {
    return null
  }

  const featureGroup = lookActiveFeature.getParent();

  const optionsButtonClick = (position, maxClickCountReached) => {

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    if (featureGroup.disabled && !featureGroup.layerPositions[position]) {
      featureGroup.disabled = false;
    }
    featureGroup.layerPositions[position] = featureGroup.layerPositions[position] ? null : featureGroup.getMatchingPositionFeature(position);

    if (featureGroup.isShowerCommonGroup) { // tool version 6 for now only
      featureGroup.checkSameShowerPositionForAnotherFeatureGroup(position)
    }

    // if (parentOptionClick) {
    //   parentOptionClick(option.feature)
    // }

    updateCanvasCount();
    forceUpdate();
  };

  const isPositionDisabled = (position) => {
    if (!featureGroup.layerPositions) return true;

    return (
      !featureGroup.layerPositions[position] &&
      !featureGroup.getMatchingPositionFeature(position, lookActiveFeature)
    );
  };

  const disabledMap = SIDE_POSITIONS.reduce((acc, pos) => {
    acc[pos] = isPositionDisabled(pos);
    return acc;
  }, {});

// show only if at least 2 options available
  const enabledCount = SIDE_POSITIONS.filter(pos => !disabledMap[pos]).length;
  if (enabledCount < 2) return null;

  return (
    <WithClickCount>
      {(maxClickCountReached) => (
        <div className="lk-feature__options">
          <span className="lk-feature__options-title">
            <FormattedMessage id="grohe.feature.placement"/>:
          </span>
          <div className="lk-feature__options-list">
            {[SIDE_POSITIONS[0], SIDE_POSITIONS[2], SIDE_POSITIONS[1]].map(position => {
              // if (position === "C") { // no need for current groups
              //   return null
              // }
              const isActive = !!featureGroup.layerPositions?.[position];
              const disabled = disabledMap[position];
              return (
                <Button className={"look-button look-button--half-radius look-button--option lk-type"
                  + (isActive ? " look-button--option-active" : "") + (disabled ? " look-button--disabled" : "")}
                        key={position}
                        disabled={disabled}
                        onClick={() => optionsButtonClick(position, maxClickCountReached)}>
                  <FormattedMessage id={"grohe.feature.placement." + position}/>
                </Button>
              )
            })}
          </div>
        </div>
      )}
    </WithClickCount>
  )
};

GroheFeatureOptionsSide.propTypes = {
  parentOptionClick: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature, featureGroupCount} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    canvasCount,
    featureGroupCount, // to update options after all features received
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsSide)
)
